<template>
  <div class="container">
    <div class="layout">
      <div class="layout_t">
        <div class="layout_tit">小程序数据概览</div>
        <div class="layout_data">数据更新于{{nowTime}}</div>
      </div>
      <target :user-conversion="userConversion" :userPvData="userPvData" />
    </div>
    <div class="layout">
      <div class="layout_t">
        <div class="layout_tit">小程序数据统计</div>
        <div class="layout_data">数据更新于昨日</div>
      </div>
      <user-status :brisk-user-data="briskUserData" :new-user-data="newUserData" />
    </div>
    <div class="layout">
      <div class="layout_t">
        <div class="layout_tit">展会数据概览</div>
        <div class="layout_data">数据更新于昨日</div>
      </div>
      <exhibition-data :exhibition-data="exhibitionData" :meeting-data="meetingData" />
    </div>
    <div class="layout">
      <div class="layout_t">
        <div class="layout_tit">主办方数据概览</div>
        <div class="layout_data">数据更新于昨日</div>
      </div>
      <host-data :host-data="hostData" />
    </div>
    <div class="layout">
      <div class="layout_t">
        <div class="layout_tit">互动数据概览</div>
        <div class="layout_data">数据更新于昨日</div>
      </div>
      <interface-data :interaction-data="interactionData" />
    </div>
    <div class="layout">
      <div class="layout_t">
        <div class="layout_tit">展会数据分析</div>
        <div class="layout_data">数据更新于昨日</div>
      </div>
      <single-exhibitionData :token="token" />
    </div>
    <div class="layout">
      <div class="layout_t">
        <div class="layout_tit">会议数据分析</div>
        <div class="layout_data">数据更新于昨日</div>
      </div>
      <single-meetingData :token="token" />
    </div>
    <van-overlay :show="loading">
      <div class="loading">
        <div class="plus-loader"></div>
        <p>数据驾驶舱报表生成中，请稍等</p>
      </div>
    </van-overlay>

  </div>

</template>

<script>
import Target from './components/Target'
import UserStatus from './components/userStatus'
import ExhibitionData from './components/exhibitionData'
import HostData from './components/hostData'
import InterfaceData from './components/interfaceData'
import SingleExhibitionData from './components/singleExhibitionData'
import SingleMeetingData from './components/singleMeetingData'

import { getMiniData, getPlatformData } from '../../api/workBenchApi'
import { GetQueryString } from '../../utils/utils'

export default {
  name: 'dataShow',
  components: {
    Target,
    UserStatus,
    ExhibitionData,
    HostData,
    InterfaceData,
    SingleExhibitionData,
    SingleMeetingData,
  },
  data() {
    return {
      //  新增用户概况
      newUserData: [
        {
          countConfig: {
            startVal: 0,
            endVal: 0,
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '日新增用户',
          colCount: 8,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: 0,
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '周新增用户',
          colCount: 8,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: 0,
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '月新增用户',
          colCount: 8,
        },
      ],
      // 小程序活跃用户概览
      briskUserData: [
        {
          countConfig: {
            startVal: 0,
            endVal: 0,
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '实名制访问人数',
          colCount: 8,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: 0,
            decimals: 0,
            prefix: '',
            suffix: '人',
            separator: ',',
            duration: 3000,
          },
          name: '日访问人数',
          colCount: 8,
        },
        {
          countConfig: {
            startVal: 0,
            endVal: 0,
            decimals: 0,
            prefix: '',
            suffix: '次',
            separator: ',',
            duration: 3000,
          },
          name: '日打开次数',
          colCount: 8,
        },
      ],
      // 小程序用户转化数据
      userConversion: [],
      // 实时访问数据
      userPvData: {
        sessionCnts: [],
        toReals: [],
        visitUvNews: [],
      },
      // 展会办个展数据概览
      exhibitionData: {},

      // 展会办个会数据概览
      meetingData: {},
      // 主办方数据概览
      hostData: {},

      // 互动数据概览
      interactionData: {},
      appKey: '',
      eventKey: '',
      token: '',
      loading: false,
      nowTime: '',
    }
  },
  mounted() {
    this.appKey = GetQueryString('appKey') || 'WX_MINI_MEHZ'
    this.eventKey = GetQueryString('eventKey') || 'MEHZ'
    this.token = GetQueryString('token')
    this.fetchData()
    this.nowTime = this.$wmtDate.fromatDate('yyyy-MM-dd hh:mm')
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true
        var headerClientInfo = { language: 'CN', eventKey: this.eventKey, appKey: this.appKey }
        let headers = {
          'x-call-client-info': JSON.stringify(headerClientInfo),
          Authorization: this.token,
          // Authorization: `4415deafcdfd4e72a49c4d20bb48b657`,
        }
        const { data } = await getMiniData(headers, {})
        this.newUserData[0].countConfig.endVal = data.yesterdayVisitUvNew
        this.newUserData[1].countConfig.endVal = data.weeklyVisitUvNew
        this.newUserData[2].countConfig.endVal = data.monthlyVisitUvNew

        this.briskUserData[0].countConfig.endVal = data.yesterdayRealVisit
        this.briskUserData[1].countConfig.endVal = data.yesterdayVisitUv
        this.briskUserData[2].countConfig.endVal = data.yesterdaySessionCnt

        this.userConversion = [data.realTotal, data.mp2, data.mp1]
        this.userPvData.sessionCnts = data.sessionCnts
        this.userPvData.toReals = data.toReals
        this.userPvData.visitUvNews = data.visitUvNews

        const { data: plateData } = await getPlatformData(headers, {
          exhibitionCode: '',
          meetingCode: '',
        })
        this.hostData = plateData.hostReportVo
        this.interactionData = plateData.interactionReportVo
        this.exhibitionData = plateData.exhibitionReportVo
        this.meetingData = plateData.meetingReportVo

        setTimeout(() => {
          this.loading = false
        }, 1200)
      } catch (e) {
        this.loading = false
        this.$toast('数据异常，请稍后重试')
        setTimeout(() => {
          wx.miniProgram.navigateBack({
            delta: 1,
          })
        }, 1200)
      }
      // setTimeout(() => {
      //   this.loading = false
      // }, 800)
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  background: #fafafa;
  min-height: 100vh;
  padding-bottom: 40px;
}
.layout {
  background: #fff;
  margin-bottom: 20px;
  &_t {
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #bbb;
  }
  &_tit {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }
  &_data {
    font-size: 14px;
    color: #bbb;
  }
}

.loading {
  position: absolute;
  top: 60%;
  left: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
  p {
    font-size: 16px;
    font-weight: bold;
    color: #409eff;
  }
}
.plus-loader:not(:required) {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 48px;
  margin-bottom: 10px;
  overflow: hidden;
  text-indent: -9999px;
  background: #f86;
  -moz-border-radius: 24px;
  -webkit-border-radius: 24px;
  border-radius: 24px;
  -moz-transform: rotateZ(90deg);
  -ms-transform: rotateZ(90deg);
  -webkit-transform: rotateZ(90deg);
  transform: rotateZ(90deg);
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -moz-animation: plus-loader-background 3s infinite ease-in-out;
  -webkit-animation: plus-loader-background 3s infinite ease-in-out;
  animation: plus-loader-background 3s infinite ease-in-out;
}

.plus-loader:not(:required)::after {
  position: absolute;
  top: 0;
  right: 50%;
  width: 50%;
  height: 100%;
  content: '';
  background: #f86;
  -moz-border-radius: 24px 0 0 24px;
  -webkit-border-radius: 24px;
  border-radius: 24px 0 0 24px;
  -moz-transform-origin: 100% 50%;
  -ms-transform-origin: 100% 50%;
  -webkit-transform-origin: 100% 50%;
  transform-origin: 100% 50%;
  -moz-animation: plus-loader-top 3s infinite linear;
  -webkit-animation: plus-loader-top 3s infinite linear;
  animation: plus-loader-top 3s infinite linear;
}

.plus-loader:not(:required)::before {
  position: absolute;
  top: 0;
  right: 50%;
  width: 50%;
  height: 100%;
  content: '';
  background: #fc6;
  -moz-border-radius: 24px 0 0 24px;
  -webkit-border-radius: 24px;
  border-radius: 24px 0 0 24px;
  -moz-transform-origin: 100% 50%;
  -ms-transform-origin: 100% 50%;
  -webkit-transform-origin: 100% 50%;
  transform-origin: 100% 50%;
  -moz-animation: plus-loader-bottom 3s infinite linear;
  -webkit-animation: plus-loader-bottom 3s infinite linear;
  animation: plus-loader-bottom 3s infinite linear;
}

@keyframes plus-loader-top {
  2.5% {
    background: #f86;
    -moz-transform: rotateY(0deg);
    -ms-transform: rotateY(0deg);
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
    -moz-animation-timing-function: ease-in;
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  13.75% {
    background: #ff430d;
    -moz-transform: rotateY(90deg);
    -ms-transform: rotateY(90deg);
    -webkit-transform: rotateY(90deg);
    transform: rotateY(90deg);
    -moz-animation-timing-function: step-start;
    -webkit-animation-timing-function: step-start;
    animation-timing-function: step-start;
  }

  13.76% {
    background: #ffae0d;
    -moz-transform: rotateY(90deg);
    -ms-transform: rotateY(90deg);
    -webkit-transform: rotateY(90deg);
    transform: rotateY(90deg);
    -moz-animation-timing-function: ease-out;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }

  25% {
    background: #fc6;
    -moz-transform: rotateY(180deg);
    -ms-transform: rotateY(180deg);
    -webkit-transform: rotateY(180deg);
    transform: rotateY(180deg);
  }

  27.5% {
    background: #fc6;
    -moz-transform: rotateY(180deg);
    -ms-transform: rotateY(180deg);
    -webkit-transform: rotateY(180deg);
    transform: rotateY(180deg);
    -moz-animation-timing-function: ease-in;
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  41.25% {
    background: #ffae0d;
    -moz-transform: rotateY(90deg);
    -ms-transform: rotateY(90deg);
    -webkit-transform: rotateY(90deg);
    transform: rotateY(90deg);
    -moz-animation-timing-function: step-start;
    -webkit-animation-timing-function: step-start;
    animation-timing-function: step-start;
  }

  41.26% {
    background: #2cc642;
    -moz-transform: rotateY(90deg);
    -ms-transform: rotateY(90deg);
    -webkit-transform: rotateY(90deg);
    transform: rotateY(90deg);
    -moz-animation-timing-function: ease-out;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }

  50% {
    background: #6d7;
    -moz-transform: rotateY(0deg);
    -ms-transform: rotateY(0deg);
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
  }

  52.5% {
    background: #6d7;
    -moz-transform: rotateY(0deg);
    -ms-transform: rotateY(0deg);
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
    -moz-animation-timing-function: ease-in;
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  63.75% {
    background: #2cc642;
    -moz-transform: rotateY(90deg);
    -ms-transform: rotateY(90deg);
    -webkit-transform: rotateY(90deg);
    transform: rotateY(90deg);
    -moz-animation-timing-function: step-start;
    -webkit-animation-timing-function: step-start;
    animation-timing-function: step-start;
  }

  63.76% {
    background: #1386d2;
    -moz-transform: rotateY(90deg);
    -ms-transform: rotateY(90deg);
    -webkit-transform: rotateY(90deg);
    transform: rotateY(90deg);
    -moz-animation-timing-function: ease-out;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }

  75% {
    background: #4ae;
    -moz-transform: rotateY(180deg);
    -ms-transform: rotateY(180deg);
    -webkit-transform: rotateY(180deg);
    transform: rotateY(180deg);
  }

  77.5% {
    background: #4ae;
    -moz-transform: rotateY(180deg);
    -ms-transform: rotateY(180deg);
    -webkit-transform: rotateY(180deg);
    transform: rotateY(180deg);
    -moz-animation-timing-function: ease-in;
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  91.25% {
    background: #1386d2;
    -moz-transform: rotateY(90deg);
    -ms-transform: rotateY(90deg);
    -webkit-transform: rotateY(90deg);
    transform: rotateY(90deg);
    -moz-animation-timing-function: step-start;
    -webkit-animation-timing-function: step-start;
    animation-timing-function: step-start;
  }

  91.26% {
    background: #ff430d;
    -moz-transform: rotateY(90deg);
    -ms-transform: rotateY(90deg);
    -webkit-transform: rotateY(90deg);
    transform: rotateY(90deg);
    -moz-animation-timing-function: ease-in;
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  100% {
    background: #f86;
    -moz-transform: rotateY(0deg);
    -ms-transform: rotateY(0deg);
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
    -moz-animation-timing-function: step-start;
    -webkit-animation-timing-function: step-start;
    animation-timing-function: step-start;
  }
}

@keyframes plus-loader-bottom {
  0% {
    background: #fc6;
    -moz-animation-timing-function: step-start;
    -webkit-animation-timing-function: step-start;
    animation-timing-function: step-start;
  }

  50% {
    background: #fc6;
    -moz-animation-timing-function: step-start;
    -webkit-animation-timing-function: step-start;
    animation-timing-function: step-start;
  }

  75% {
    background: #4ae;
    -moz-animation-timing-function: step-start;
    -webkit-animation-timing-function: step-start;
    animation-timing-function: step-start;
  }

  100% {
    background: #4ae;
    -moz-animation-timing-function: step-start;
    -webkit-animation-timing-function: step-start;
    animation-timing-function: step-start;
  }
}

@keyframes plus-loader-background {
  0% {
    background: #f86;
    -moz-transform: rotateZ(180deg);
    -ms-transform: rotateZ(180deg);
    -webkit-transform: rotateZ(180deg);
    transform: rotateZ(180deg);
  }

  25% {
    background: #f86;
    -moz-transform: rotateZ(180deg);
    -ms-transform: rotateZ(180deg);
    -webkit-transform: rotateZ(180deg);
    transform: rotateZ(180deg);
    -moz-animation-timing-function: step-start;
    -webkit-animation-timing-function: step-start;
    animation-timing-function: step-start;
  }

  27.5% {
    background: #6d7;
    -moz-transform: rotateZ(90deg);
    -ms-transform: rotateZ(90deg);
    -webkit-transform: rotateZ(90deg);
    transform: rotateZ(90deg);
  }

  50% {
    background: #6d7;
    -moz-transform: rotateZ(90deg);
    -ms-transform: rotateZ(90deg);
    -webkit-transform: rotateZ(90deg);
    transform: rotateZ(90deg);
    -moz-animation-timing-function: step-start;
    -webkit-animation-timing-function: step-start;
    animation-timing-function: step-start;
  }

  52.5% {
    background: #6d7;
    -moz-transform: rotateZ(0deg);
    -ms-transform: rotateZ(0deg);
    -webkit-transform: rotateZ(0deg);
    transform: rotateZ(0deg);
  }

  75% {
    background: #6d7;
    -moz-transform: rotateZ(0deg);
    -ms-transform: rotateZ(0deg);
    -webkit-transform: rotateZ(0deg);
    transform: rotateZ(0deg);
    -moz-animation-timing-function: step-start;
    -webkit-animation-timing-function: step-start;
    animation-timing-function: step-start;
  }

  77.5% {
    background: #f86;
    -moz-transform: rotateZ(270deg);
    -ms-transform: rotateZ(270deg);
    -webkit-transform: rotateZ(270deg);
    transform: rotateZ(270deg);
  }

  100% {
    background: #f86;
    -moz-transform: rotateZ(270deg);
    -ms-transform: rotateZ(270deg);
    -webkit-transform: rotateZ(270deg);
    transform: rotateZ(270deg);
    -moz-animation-timing-function: step-start;
    -webkit-animation-timing-function: step-start;
    animation-timing-function: step-start;
  }
}
</style>


<style scoped>
.van-overlay {
  background-color: rgba(0, 0, 0, .9) !important;
}
</style>